import styled from "styled-components";

const WidgetFrameTitleSpacer = styled.div`
    flex-grow: 1;
`;

export { WidgetFrameTitleSpacer };
